import { ChangeEvent, FC } from "react";
import { Flex, Radio } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { BillingInterval, PlanType } from "sdk/types";
import { BillingIntervalRadioLabel } from "./BillingIntervalRadioLabel";
import { Values } from "./types";

export interface BillingIntervalRadioOption {
  plan: PlanType;
  value: BillingInterval;
}

interface Props extends BillingIntervalRadioOption {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const BillingIntervalRadioOption: FC<Props> = ({ plan, value }) => {
  const { resetForm } = useFormikContext<Values>();

  const handleChange = () => {
    resetForm({
      values: {
        billingInterval: value,
        coupon: undefined,
        promoCode: "",
      },
    });
  };

  return (
    <Flex w="full">
      <Radio
        mt={1}
        onChange={handleChange}
        value={value}
        variant="th-outline-2"
        size="xl"
        spacing={{ base: 4, md: 2 }}
        w="full"
      >
        <BillingIntervalRadioLabel interval={value} plan={plan} />
      </Radio>
    </Flex>
  );
};
